import { ReadProjectStorePeriod } from "@/types/projectStorePeriod";
import { PeriodFilter } from "@/modules/projects/types/periodFilter";
import { useEffect, useMemo, useState } from "react";

const usePeriodFilter = (data: ReadProjectStorePeriod[]): PeriodFilter => {
  const allPeriods = useMemo(() => {
    if (data.length === 0) {
      return [];
    }
    return [...new Set(data[0].periods.map((period) => period.period))];
  }, [data]);

  const firstPeriod = useMemo(() => allPeriods[0], [allPeriods]);
  const lastPeriod = useMemo(
    () => allPeriods[allPeriods.length - 1],
    [allPeriods],
  );

  const [fromDate, setFromDate] = useState<string>(firstPeriod);
  const [toDate, setToDate] = useState<string>(lastPeriod);

  useEffect(() => {
    setFromDate(firstPeriod);
    setToDate(lastPeriod);
  }, [firstPeriod, lastPeriod]);

  return { fromDate, toDate, setFromDate, setToDate, options: allPeriods };
};

export default usePeriodFilter;
